export default {
  data: function data() {
    return {
      mediaBase: process.env.VUE_APP_MEDIA_URL,
      testVar: "Hello This is me",
    };
  },
};
